var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-helping_hand 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5482 2.22083L22.579 5.18916C22.204 5.56416 21.7615 5.86416 21.274 6.07166L15.6965 8.46249C14.4657 8.98999 13.5198 10.0183 13.0773 11.3458L11.7832 16.185L10.1348 20.1758C9.49482 22.0958 11.6473 23.885 13.4348 22.8125C13.8723 22.55 14.3173 22.2092 14.7557 21.7717C17.4882 19.0392 20.5565 15.3483 20.5565 15.3483C20.5565 15.3483 27.1648 15.3292 28.8207 15.3483C31.994 15.385 32.8448 17.9658 30.7348 20.0892C32.8348 23.2842 29.8607 24.9808 29.8607 24.9808C29.8607 24.9808 32.3773 27.6542 29.4215 30.0275C31.0698 32.3933 29.1315 35.3725 25.814 35.3908C24.1082 35.4008 18.5482 35.4458 15.7648 35.4167C14.8682 35.4075 13.4065 35.5767 12.7723 36.2108L11.9957 36.9875",
    strokeWidth: 2.5,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.63086 24.9583L11.9934 14.5958",
    strokeWidth: 2.5,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.2227 23.4699C31.2227 23.4699 33.9393 20.8432 35.321 19.3715C36.1677 18.4707 36.6868 17.4415 36.7827 15.9782C36.8518 14.9332 37.2577 13.1049 37.9977 12.3649L38.5118 11.8507",
    strokeWidth: 2.5,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc3);
export default __webpack_public_path__ + "static/media/ic (3).3b23d9b7c4de0bd226165dcc04d101a9.svg";
export { ForwardRef as ReactComponent };